import { render, staticRenderFns } from "./ListProduct.vue?vue&type=template&id=671433af&scoped=true&"
import script from "./ListProduct.vue?vue&type=script&lang=js&"
export * from "./ListProduct.vue?vue&type=script&lang=js&"
import style0 from "./ListProduct.vue?vue&type=style&index=0&id=671433af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671433af",
  null
  
)

export default component.exports